import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendConversationMessage } from '@/api/conversations';
import { invalidateAfterSend, patchMessagesCache } from './inbox-cache';

/**
 * Respuesta MANUAL del asesor desde el panel (módulo 5) — **texto**.
 *
 * El `POST` envía de verdad por el canal del contacto (WhatsApp) y guarda el saliente en el
 * historial, así que la diferencia con el handoff (`use-set-bot-active`, solo `ADMIN`) es que acá
 * **cualquier miembro** puede escribir: responder es justo lo que hace el AGENTE_HUMANO.
 *
 * Dos consecuencias del contrato que se ven en el código:
 *  - el backend responde **502 y no guarda nada** cuando el canal no pudo entregar el mensaje (el
 *    caso típico: pasaron más de 24 h desde el último mensaje del cliente). Por eso el error se pinta
 *    tal cual —con el arreglo que sugiere el backend— en vez de mostrar un "enviado";
 *  - la respuesta es la fila REAL del mensaje, así que el hilo se actualiza con ella en vez de
 *    rehacer la petición (ver `inbox-cache.ts`).
 *
 * La versión con FOTO es `useSendImage` (`use-send-image.ts`), que comparte la caché con esta.
 */

export interface SendMessageInput {
  conversationId: string;
  contenido: string;
}

export function useSendMessage(tenantId: string | null, conversationId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ conversationId: id, contenido }: SendMessageInput) =>
      sendConversationMessage(tenantId ?? '', id, contenido),

    onSuccess: (mensaje, variables) => {
      if (!tenantId) return;

      patchMessagesCache(queryClient, tenantId, variables.conversationId, mensaje);
      invalidateAfterSend(queryClient, tenantId, variables.conversationId);
    },
  });
}
